import { useTranslation } from 'react-i18next';
import { CONTACT } from '../../config/contact';
import styles from './Footer.module.css';

const Footer = () => {
  const { t } = useTranslation('common');

  return (
    <footer className={styles.footer}>
      <div className={styles.footerContainer}>
        <div>
          <a href="#top" className={styles.wordmark}>
            STACK<span>COMBO</span><i />
          </a>
          <h4>{t('brand.tagline')}</h4>
          <p>{t('brand.builtBy')}</p>
        </div>
        <div className={styles.contact}>
          <strong>{t('footer.contact')}</strong>
          {CONTACT.phone} &middot; {CONTACT.email}
        </div>
        <div className={styles.copyright}>{t('footer.copyright')}</div>
      </div>
    </footer>
  );
};

export default Footer;
